import qs from 'qs';
import request from '../index';
/** 和售后管理有关的接口 **/

/** 
* AfterSaleRepair
* @params {string} data.afterSaleProblemDescription 售后问题描述
* @params {} data.columbaAccessory 
* @params {string} data.contactPerson 对接人
* @params {string} data.createTime 创建时间
* @params {number} data.createUserId 
* @params {array} data.faultInfo 
* @params {number} data.id 
* @params {string} data.localDate 日期
* @params {string} data.notes 备注
* @params {string} data.picture 图片
* @params {string} data.repairCustomerInfo 返修客户信息
* @params {number} data.repairEquipmentId 
* @params {string} data.serial 机身号
* @params {string} data.serialType 机身号类型(天鹅/天鸽)
* @params {string} data.solution 解决方案：返修换机/现场维修/远程处理/返修不换机/设备升级/其他
* @params {} data.swanAccessory 
* @params {string} data.usageDuration 设备使用时长
* @params {string} data.video 视频
* @params {string} data.year 年度
*/

/** 
* 删除日常报修
* @params {array} ids
*/
export const deleteAfterSaleRepair = (data) => request.delete('/api-qc/deleteAfterSaleRepair', { data });

/** 
* 删除故障信息
* @params {array} ids
*/
export const deleteFaultInfo = (data) => request.delete('/api-qc/deleteFaultInfo', { data });

/** 
* 获取日常报修列表
* @params {number} params.lineNum 每页显示多少条
* @params {string} params.localDate 日期
* @params {number} params.pageNum 页码
* @params {string} params.serial 机身号
* @params {string} params.serialType 机身号类型
*/
export const getAfterSaleRepairList = (params) => request.get('/api-qc/getAfterSaleRepairList', { params });

/** 
* 添加日常报修信息
* @params {AfterSaleRepair} afterSaleRepair
*/
export const insertAfterSaleRepair = (data) => request.post('/api-qc/insertAfterSaleRepair', data);

/** 
* 保存故障信息
*/
export const saveFaultInfo = (data) => request.put('/api-qc/saveFaultInfo', data);

/** 
* 修改日常报修信息
* @params {AfterSaleRepair} afterSaleRepair
*/
export const updateAfterSaleRepair = (data) => request.put('/api-qc/updateAfterSaleRepair', data);

/**
 * 导出日常报修
*/
export const exportAfterSaleRepair = (ids) => request.get(`api-qc/exportAfterSaleRepair?${ids}`, {
    responseType: 'blob'
});
